/** Word 题库上传：规范化 .docx 的 MIME，兼容 WPS/微信等上报非标准类型的环境 */

export const DOCX_MIME =
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'

const TRUSTED_DOCX_MIMES = new Set([
  DOCX_MIME,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  'application/zip',
  'application/x-zip-compressed',
  'application/octet-stream',
  'binary/octet-stream',
  ''
])

/**
 * 若浏览器/微信/WPS 给出的 type 不在常见 docx 白名单，则包装为 standard docx MIME。
 * 后端仍以 zip 结构校验为准；此处主要避免国产环境误报导致上传被拒。
 */
export function normalizeDocxUploadFile(file) {
  if (!file) return file
  const name = file.name || 'upload.docx'
  const type = (file.type || '').split(';')[0].trim().toLowerCase()
  if (TRUSTED_DOCX_MIMES.has(type)) {
    return file
  }
  try {
    return new File([file], name, {
      type: DOCX_MIME,
      lastModified: file.lastModified || Date.now()
    })
  } catch {
    return file
  }
}
